import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "paddingPreset", "customPadding"]
  static values = { open: { type: Boolean, default: false } }

  connect() {
    this.syncOpenState()
    this.syncCustomPadding()
  }

  toggle(event) {
    event.preventDefault()
    this.openValue = !this.openValue
    this.syncOpenState()
  }

  paddingPresetChanged() {
    this.syncCustomPadding()
  }

  syncOpenState() {
    this.element.classList.toggle("is-open", this.openValue)
    this.panelTarget.classList.toggle("d-none", !this.openValue)

    const toggleButton = this.element.querySelector(".site-block-style__toggle")
    if (toggleButton) {
      toggleButton.setAttribute("aria-expanded", this.openValue ? "true" : "false")
    }
  }

  syncCustomPadding() {
    if (!this.hasCustomPaddingTarget) return

    const presetValue = this.hasPaddingPresetTarget ? this.paddingPresetTarget.value : ""
    this.customPaddingTarget.classList.toggle("d-none", presetValue !== "custom")
  }
}
